import { css } from '@emotion/react';

const GrowthChartStyles = css`
    position: relative;

    .date-filter-container {
        display: flex;
        align-items: center;
        position: absolute;
        z-index: 10;
        left: 25rem;
    }

    .date-picker-conatiner {
        display: flex;
        position: absolute;
        z-index: 10;
        left: 25rem;
        top: 2rem;

        .start-date-container {
            margin-right: 1rem;
        }

        .date-select {
            margin-right: 0.5rem;
        }
    }

    .total-returns {
        position: absolute;
        top: 2rem;
        left: 55rem;
        z-index: 3;
    }

    .highcharts-tooltip {
        path {
            stroke: none;
            stroke-width: 0;
            fill: transparent;
        }

        .custom-tootltip-container {
            position: absolute;
            top: 2rem;
            left: 2.5rem;
            z-index: 1;

            .tooltip-value {
                font-weight: bold;
            }
        }
    }
`;

export const themeGrowthChartStyles = css`
    position: relative;

    .date-filter-container {
        display: flex;
        align-items: center;
        position: absolute;
        z-index: 10;
        left: 25rem;
    }

    .investment-amount {
        .growth-chart-label {
            font-family: var(--font-family-regular);
            font-weight: var(--font-weight-bold);
            font-size: var(--font-size-small);
            color: var(--default-text-color);
        }

        .growth-amount-input {
            font-family: var(--font-family-regular);
            font-weight: var(--font-weight-regular);
            font-size: var(--font-size-small);
            color: var(--default-text-color);
        }
    }

    .date-picker-conatiner {
        display: flex;
        position: absolute;
        z-index: 10;
        left: 25rem;
        top: 2rem;
        font-family: var(--font-family-regular);
        font-weight: var(--font-weight-regular);
        font-size: var(--font-size-small);
        color: var(--default-text-color);

        .start-date-container {
            margin-right: 1rem;
        }

        .date-select {
            margin-right: 0.5rem;
        }
    }

    .total-returns {
        position: absolute;
        top: 2rem;
        left: 55rem;
        z-index: 3;

        .total-returns-label {
            font-family: var(--font-family-regular);
            font-weight: var(--font-weight-regular);
            font-size: var(--font-size-xx-small);
            color: var(--default-text-color);
        }
    }

    .highcharts-tooltip {
        path {
            stroke: none;
            stroke-width: 0;
            fill: transparent;
        }

        .custom-tootltip-container {
            position: absolute;
            top: 2rem;
            left: 2.5rem;
            z-index: 1;

            .tooltip-value {
                font-family: var(--font-family-regular);
                font-weight: var(--font-weight-bold);
                font-size: var(--font-size-small);
                color: var(--default-text-color);
            }
        }
    }

    .integrated-date-picker-container {
        display: flex;
        align-items: center;
        position: absolute;
        z-index: 10;
        left: 25rem;
        top: 2rem;
    }

    .react-datepicker-wrapper {
        width: auto;
        width: auto;
        display: flex;
        align-items: center;

        .react-datepicker {
            .year-select {
                margin-right: 0.5rem;
            }
        }
    }

    .start-date-container,
    .end-date-container {
        margin-right: 1rem;
    }

    .custom-react-date-picker-select {
        .custom-react-date-picker-select-option {
            cursor: pointer;
        }

        &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }

        &::-webkit-scrollbar-track {
            background: var(--color-white);
        }

        &::-webkit-scrollbar-thumb {
            background: var(--color-grey);
            border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: var(--color-grey);
        }
    }

    .custom-date-picker-input {
        display: flex;
        align-items: center;
        border: 1px solid var(--color-border);
        width: 9rem;
        border-radius: 5px;
        color: var(--color-text-primary);

        .custom-date-picker-icon-right {
            margin-left: auto;
        }

        .custom-date-picker-icon-left {
            margin-right: auto;
        }

        .custom-date-picker-image {
            width: 1rem;
            height: 1rem;
        }
    }
`;

export default GrowthChartStyles;
